function highlight(text: string): string {
  return text
    .replace(/&lt;b&gt;/g, "<span class='clip-detail__highlight'>")
    .replace(/&lt;\/b&gt;/g, "</span>")
    .replace(/<b>/g, "<span class='clip-detail__highlight'>")
    .replace(/<\/b>/g, "</span>");
}

export default highlight
